export enum EDowntimeRefundStatus {
	SUCCESS = 'SUCCESS',
	PROCESSING = 'PROCESSING'
}

export enum GameNames {
	LUDO = 'ludo',
	NINJA = 'ninja',
	SNLT = 'snlt',
	TURBO = 'turbo',
	TC = 'tc',
	LUDONX = 'ludonx'
}

export enum DowntimeRefundRequestStatus {
	IN_PROGRESS = 0,
	WAITING_FOR_APPROVAL = 1,
	APPROVED = 2,
	REJECTED = 3,
	FAILED = 4
}

export const DowntimeRefundAction = {
	APPROVE: 'approve',
	REJECT: 'reject',
	DOWNLOAD: 'download',
	GET_REFUND_STATUS: 'getRefundStatus',
	ADD: 'add'
};

export const DowntimeRefundActionLabel = {
	[DowntimeRefundAction.APPROVE]: 'Approve Refund Request',
	[DowntimeRefundAction.REJECT]: 'Reject Refund Request',
	[DowntimeRefundAction.DOWNLOAD]: 'Download Requested Data',
	[DowntimeRefundAction.GET_REFUND_STATUS]: 'Get Bulk Refund Status',
	[DowntimeRefundAction.ADD]: 'Create Refund Request'
};
